import React, {  } from 'react';

import { collateOptions } from '../types';
import { IntlFunction } from './Intl.Function';

export const IntlCollatorResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator/resolvedOptions"
		header="Intl.Collator.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and collation options computed during initialization of this [Intl.Collator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator) object."
		options={collateOptions}
		ruleSet={[]}
		template="new Intl.Collator(##locale##, ##options##).resolvedOptions()" />
)